import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { MenuConfigContext } from "./menuConfig";

/**
 * Sidebar link with active-state styling. Super admins can rename, reorder or hide it per role (Menu Settings).
 * @param {{ to: string, icon: React.ComponentType<any>, label: string, testId?: string, badge?: number }} props
 */
export default function NavItem({ to, icon: Icon, label, testId, badge }) {
  const { items, order } = useContext(MenuConfigContext);
  const cfg = items[to] || {};
  if (cfg.hidden) return null;
  return (
    <NavLink
      to={to}
      data-testid={testId}
      end
      style={{ order: cfg.order ?? order[to] ?? 9999 }}
      className={({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 border-l-4 transition-colors duration-100 ${
          isActive
            ? "bg-black text-white border-black"
            : "text-zinc-900 border-transparent hover:bg-zinc-100 hover:border-black"
        }`
      }
    >
      <Icon size={18} weight="bold" />
      <span className="text-[13px] font-medium tracking-tight">{cfg.label || label}</span>
      {badge > 0 && (
        <span className="ml-auto min-w-[22px] bg-amber-400 px-1.5 py-0.5 text-center font-mono text-[10px] font-bold leading-none text-black"
              aria-label={`${badge} waiting`} data-testid={`${testId}-badge`}>
          {badge > 99 ? "99+" : badge}
        </span>
      )}
    </NavLink>
  );
}
